import React from 'react';

const toRootPage = (path: string) => {
    if (path.startsWith('~')) path = path.substring(1);
    if (path.startsWith('/')) path = path.substring(1);
    const result = `~/${path.replace(/\/\//g, '/')}`;
    return result;
};

export const getReturnLocation = () => {
    try {
        const val = sessionStorage.getItem('deqo/ui/returnTo');
        if (val) return toRootPage(JSON.parse(val));
    }
    catch { /* ignore */ }
    return '~/';
};

export const useReturnLocation = (href: string) => {
    sessionStorage.setItem('deqo/ui/returnTo', JSON.stringify(href));
};

// eslint-disable-next-line react/display-name
export const UseReturnLocation = React.memo<{ href }>(({ href }) => {
    useReturnLocation(href);
    return null;
});
